module.exports = __webpack_public_path__ + "static/media/layout3-vid.937d2cd8.svg";